var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M3.80331 1.16009C3.93624 0.996994 4.1355 0.902344 4.34591 0.902344H18.1957C18.7776 0.902344 19.1055 1.57116 18.749 2.03113L16.3782 5.09031C16.2456 5.2614 16.0414 5.36152 15.8249 5.36152H1.8525C1.26258 5.36152 0.937197 4.67655 1.3099 4.21927L3.80331 1.16009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M3.80331 12.8945C3.93624 12.7314 4.1355 12.6367 4.34591 12.6367H18.1957C18.7776 12.6367 19.1055 13.3055 18.749 13.7655L16.3782 16.8247C16.2456 16.9958 16.0414 17.0959 15.8249 17.0959H1.8525C1.26258 17.0959 0.937197 16.4109 1.3099 15.9536L3.80331 12.8945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M3.99329 10.9695C4.12617 11.1345 4.32665 11.2305 4.53854 11.2305H18.206C18.7861 11.2305 19.1144 10.5655 18.7619 10.105L16.42 7.04579C16.2876 6.87276 16.0821 6.77129 15.8642 6.77129H2.07554C1.48757 6.77129 1.16157 7.45229 1.5303 7.91027L3.99329 10.9695Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/SolanaIcon.53dd4fa331e73bf3aee5333f96049e4a.svg";
export { ForwardRef as ReactComponent };